<!-- Footer -->
<p class="clearfix mb-0 text-center">
  <span class="float-md-center d-block d-md-inline-block mt-25">
    &copy; Grupo Copico {{ year }}    
    <span class="d-none d-sm-inline-block">, Todos los derechos reservados. | <a style="color:white;" href="https://copicocorp.com/avisoDePrivacidad/">Avisos de Privacidad.</a></span>
  </span>  
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>